import EmptyLayout from '@/modules/core/layouts/EmptyLayout.vue';
import ViewLogin from './ViewLogin.vue';
import ViewDirectLogin from './ViewDirectLogin.vue';
import isAuth from '@/modules/core/security/isAuth';
import { logout } from './service';
import { getTipoUsuario } from '../shared/storage';

const REDIRECT_PATHS = {
  0: '/admin/empresas',
  1: '/dashboards/visionone',
  2: '/admin/empresas',
};

const validarAcessoLogin = () => {
  const tipoUsuario = getTipoUsuario();
  if (tipoUsuario == null || typeof tipoUsuario !== 'number' || !isAuth()) return true;
  return { path: REDIRECT_PATHS[tipoUsuario] };
};

const executarLogout = () => {
  logout();
  return { path: '/' };
};

export default {
  path: '/auth',
  alias: '/',
  component: EmptyLayout,
  children: [
    {
      name: 'login',
      path: '',
      component: ViewLogin,
      beforeEnter: validarAcessoLogin,
    },
    {
      name: 'Logout',
      path: 'logout',
      beforeEnter: executarLogout,
    },
    {
      name: 'DirectLogin',
      path: 'directLogin/:params+',
      component: ViewDirectLogin,
    },
  ],
};
